import { Box, TableRow } from "@mui/material"
import * as React from "react"
import { Draggable } from "react-beautiful-dnd"
import { permissions } from "../../../../../config/constants"
import { useSelector } from "react-redux"

export default function DraggableMetric(props: any) {
  const { index, child } = props

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  return (
    <Draggable
      draggableId={`${index}`}
      index={index}
      disableInteractiveElementBlocking
      isDragDisabled={
        !allPerms?.includes(permissions?.BLUEPRINT_METRIC_MAINTENANCE)
      }
    >
      {(draggableProvided: any) => (
        <Box
          // sx={{ none }}
          sx={{ display: "flex" }}
          ref={draggableProvided.innerRef}
          {...draggableProvided.draggableProps}
          {...draggableProvided.dragHandleProps}
        >
          {React.cloneElement(child, {
            ...props,
            ...draggableProvided.dragHandleProps,
            style: { cursor: "inherit" },
          })}
        </Box>
      )}
    </Draggable>
  )
}
